import React, {useContext, useReducer} from "react";
import Loading from "../component/loading/Loading";


const LoadingStateContext = React.createContext()
const LoadingDispatchContext = React.createContext()

export const actionTypes = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
}

export function useLoadingDispatcher() {
    const context = useContext(LoadingDispatchContext)

    if (!context)
        throw Error('useAuthDispatcher must be use with a LoadingProvider')

    return context
}

export function useLoadingState() {
    const context = useContext(LoadingStateContext)

    if (!context)
        throw Error('useAuthDispatcher must be use with a LoadingProvider')

    return context
}

export function LoadingProvider({children}) {
    let [state, dispatch] = useReducer(loadingReducer, {loading: false,showBackground: false})

    return (
        <LoadingStateContext.Provider value={state}>
            <LoadingDispatchContext.Provider value={dispatch}>
                {children}
                <Loading/>
            </LoadingDispatchContext.Provider>
        </LoadingStateContext.Provider>
    )
}


function loadingReducer(state, action) {
    switch (action.type) {
        case actionTypes.SHOW:
            return {
                showBackground:action.showBackground,
                loading: true
            }
        case actionTypes.HIDE:
            return {
                loading: false
            }
        default:
            return {
                loading: false
            }

    }
}


export function setLoadingStateDispatch(state, background = false) {
    let dispatch = {}
    if (state) {
        dispatch = {
            type: actionTypes.SHOW,
            showBackground:background
        }
    } else {
        dispatch = {
            type: actionTypes.HIDE
        }
    }

    return dispatch
}